import EventBase from './EventBase'
import EventID from './EventID'


export default class EventReturnGameUI extends EventBase {
    /**
     * 关闭高级 UI 界面事件构造函数
     */
    constructor() {
        super()
        this.Parameter = ['0', '1', '1', '0']
    }

    /**
     * 获取事件ID
     */
    Code = EventID.ReturnGameUI

    get isFadeOut() {
        return this.Parameter[1] === '1'
    }

    set isFadeOut(val: boolean) {
        this.Parameter[1] = val ? '1' : '0'
    }

    get Time() {
        // if (this.Parameter.length === 3) {
        //     return parseInt(this.Parameter[1])
        // }

        return parseInt(this.Parameter[2])
    }

    set Time(val: number) {
        // if (this.Parameter.length === 3) {
        //     this.Parameter[1] = val.toString()
        // }

        this.Parameter[2] = val.toString()
    }

    get type() {
        // 0: 帧; 1: 秒
        // return parseInt(this.Parameter[this.Parameter.length - 1])
        return parseInt(this.Parameter[3])
    }

    set type(val: number) {
        // this.Parameter[this.Parameter.length - 1] = val.toString()
        this.Parameter[3] = val.toString()
    }

    /**
     * 获取描述信息
     */
}
